<template>
  <!--<v-app id="inspire">-->
  <v-main class="ma-0 pa-0">
    <form @submit.prevent="submit" method="POST">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title v-if="!token">
                  Логин
                  {{ token }}
                </v-toolbar-title>
                <v-toolbar-title v-else>
                  Сброс пароля
                  {{ token }}
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field v-if="!token"
                                v-model.trim="username"
                                :rules="emailRules"
                                prepend-icon="person"
                                name="login"
                                label="Логин"
                                type="text"
                                required />
                  <v-text-field id="password"
                                v-model.trim="password"
                                :append-icon="show ? 'visibility' : 'visibility_off'"
                                :rules="[ v => !!v || 'Пароль обязателен']"
                                :type="show ? 'text' : 'password'"
                                @click:append="show = !show"
                                prepend-icon="lock"
                                name="password"
                                label="Пароль"
                                required />
                  <v-text-field id="passwordRep"
                                v-if="token"
                                v-model.trim="passwordRep"
                                :append-icon="show ? 'visibility' : 'visibility_off'"
                                :rules="[ v => !!v || 'Пароль обязателен', passwordConfirmationRule]"
                                :type="show ? 'text' : 'password'"
                                @click:append="show = !show"
                                prepend-icon="lock"
                                name="passwordRep"
                                label="Повторите пароль"
                                required />
                </v-form>
                <v-alert v-show="isError"
                         :value="!!alert.type"
                         :type="alert.type">
                  {{ alert.message }}
                </v-alert>
                <v-row class="fill-height"
                       align="start"
                       justify="end">
                  <v-btn v-if="!token"
                         :disabled="username === ''"
                         @click="requestResetPwd"
                         text
                         small>
                    Забыли пароль?
                  </v-btn>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <!--                <v-btn v-if="!token" @click="handleClickSignIn">-->
                <!--                  <span class="google-button__icon">-->
                <!--                    <svg viewBox="0 0 366 372" xmlns="http://www.w3.org/2000/svg">-->
                <!--                      <path id="Shape" d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z" fill="#EA4335" /><path id="Shape" d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z" fill="#FBBC05" /><path id="Shape" d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z" fill="#4285F4" /><path d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z" fill="#34A853" /></svg>-->
                <!--                  </span>-->
                <!--                  <span class="google-button__text" />-->
                <!--                </v-btn>-->
                <v-btn v-if="!token" @click="handleClickSignIn" icon>
                  <v-icon>mdi-google</v-icon>
                </v-btn>

                <v-btn v-if="!token" @click="authenticate" color="primary">
                  Войти
                </v-btn>
                <v-btn v-if="token"
                       @click="cancelUpdate"
                       color="primary">
                  Отмена
                </v-btn>
                <v-btn v-if="token"
                       :disabled="!passwordsChecked"
                       @click="update"
                       color="primary">
                  Обновить
                </v-btn>
              </v-card-actions>
            </v-card>
            <BaseDialog
              :visible="dialogReset"
              dialog-title="Смена пароля">
              <template slot="body">
                <v-card-text>
                  <p>Запрос на сброс пароля отправлен на почту</p>
                  <p>Дождитесь письма и смените пароль</p>
                </v-card-text>
              </template>
              <template slot="footer">
                <v-btn @click="dialogReset = false"
                       color="primary"
                       dark
                       class="mb-2"
                       tile
                       outlined>
                  Ок
                </v-btn>
              </template>
            </BaseDialog>
          </v-col>
        </v-row>
      </v-container>
    </form>
  </v-main>

  <!--</v-app>-->
</template>

<script>
// import { EventBus } from '@/utils'
// import axios from 'axios'
import {API_URL} from '../_services'
import BaseDialog from './base/BaseDialog'

export default {
  name: "Login",
  components: {BaseDialog},
  props: {
    source: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isSignIn: false,
    isInit: false,
    drawer: null,
    username: null,
    password: null,
    show: false,
    dialogReset: false,
    passwordRep:null,
    isError: false,
    emailRules: [
      v => !!v || 'Почта обязательна',
      v => /.+@.+\..+/.test(v) || 'Неверный формат почты'
    ]
  }),
  computed: {
    alert () {
      return this.$store.state.alert
    },
    passwordConfirmationRule () {
      return () => (this.password === this.passwordRep) || 'Пароли должны совпадать'
    },
    passwordsChecked () {
      return this.password === this.passwordRep && this.password
    },
  },

  created () {
    // reset login status
    this.$store.dispatch('authentication/logout')
  },
  methods: {
    update () {
      const {dispatch} = this.$store
      const token = this.token
      const password = this.password
      let vm = this
      if (this.token && this.password) {
        dispatch('authentication/resetPwd', {password, token}).then(vm.isError = false).catch((error) => {
         vm.isError = true
        })
      }
    },
    cancelUpdate () {
      this.token=null
    },
    authenticate () {
      const {username, password} = this
      const {dispatch} = this.$store
      let vm = this
      if (username && password) {
        dispatch('authentication/login', {username, password}).then( resp => {
            vm.isError = false
        }
        ).catch((error) => {
          vm.isError = true
        })
      }
    },
    requestResetPwd () {
      this.dialogReset = true
      const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({'email':this.username})
      }
      let vm = this
      return fetch(`${API_URL}/reset_password`, requestOptions)
          // .then(handleLoginResponse)
          .then(resp => {
            vm.dialogReset = true
          }).catch((error) => {
            vm.isError = true
            throw new Error(error)
      })
    },
    handleClickSignIn () {
      const {dispatch} = this.$store
      let vm=this
      this.$gAuth.signIn()
        .then(user => {
          let username = null
          let avatar = null
          if (user.w3) {
            username = user.w3.getEmail()
            avatar = user.w3.getImageUrl()
          } else
          {
            username = user.Qt.zu
            avatar = user.Qt.jL
          }
          if (this.$gAuth.isAuthorized && username)
            dispatch('authentication/googleLogin', {username, avatar}).catch((error) => {
              // //console.log(error)
            })

        })
        .catch(error => {
          vm.isError = true
          // On fail do something
        })
    }

  },

}
</script>

<style lang="scss" scoped>
.google-button {
  height: 40px;
  border-width: 0;
  background: white;
  color: #737373;
  border-radius: 5px;
  white-space: nowrap;
  box-shadow: 1px 1px 0px 1px rgba(0, 0, 0, 0.05);
  transition-property: background-color, box-shadow;
  transition-duration: 150ms;
  transition-timing-function: ease-in-out;
  padding: 0;

  &:focus,
  &:hover {
    box-shadow: 1px 4px 5px 1px rgba(0, 0, 0, 0.1);
  }

  &:active {
    background-color: #e5e5e5;
    box-shadow: none;
    transition-duration: 10ms;
  }
}

.google-button__icon {
  display: inline-block;
  vertical-align: middle;
  margin: 8px 0 8px 8px;
  width: 18px;
  height: 18px;
  box-sizing: border-box;
}

.google-button__icon--plus {
  width: 27px;
}

.google-button__text {
  display: inline-block;
  vertical-align: middle;
  padding: 0 24px;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Roboto', arial, sans-serif;
}

// Boilerplate stuff

html, body {
  height: 100%;
}

body {
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

button ~ button {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue